import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface AgentStatus {
    taskId: string
    working: boolean
    startedAt: { seconds: number } | null
}

interface AgentStatusState {
    status: AgentStatus | null
}

const initialState: AgentStatusState = {
    status: null,
}

const agentStatusSlice = createSlice({
    name: 'agentStatus',
    initialState,
    reducers: {
        // Saga triggers — listen to agent_status/{taskId} while the task is open.
        startAgentStatusListening: (_state, _action: PayloadAction<{ taskId: string; workspaceId: string }>) => {},
        stopAgentStatusListening: () => {},
        // State mutations.
        setAgentStatus: (state, action: PayloadAction<AgentStatus>) => {
            state.status = action.payload
        },
        clearAgentStatus: (state) => {
            state.status = null
        },
    },
})

export const {
    startAgentStatusListening,
    stopAgentStatusListening,
    setAgentStatus,
    clearAgentStatus,
} = agentStatusSlice.actions

export default agentStatusSlice.reducer
